import { Text, Button } from "native-base";
import colors from "theme/colors";
import { useTranslation } from "react-i18next";
import AmplitudeHelper from "utils/analytics";
import { showComponents } from "pages/SingleCreate/utils";
import { getIfSDA } from "utils/utilities";
import { getStore } from "store/storeUtils";
import { useNavigate } from "react-router-dom";
import { SD_AGENT_PAGE, SD_LANDING_PAGE } from "global/paths";
import { CREATE_MODALS } from "global/constants";

export const checkIfActive = (route) => {
  if (route.path === "/" && location.pathname !== "/") {
    return route?.children?.some((subRoute) => {
      return location.pathname === subRoute.path;
    });
  }
  return location.pathname.startsWith(route.path);
};

const RouteButton = ({ route = "", isFileUploading = false, showModalForDisableUpload = () => {} }) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { employerConfigData, sdAgentFlowInProgress, modal, setModal } = getStore();
  const isCurrentRoute = checkIfActive(route);

  const isSda = getIfSDA(employerConfigData);
  if (!employerConfigData) return null;

  if (!isSda && route?.isSDA) return null;

  // Sidebar SD click while an SD Agent submission is mid-flight on /sd/agent lands
  // on the classic flow — confirm (and clear the agent session) before switching
  // Same global-location idiom as checkIfActive above
  const needsSdAgentGuard =
    route?.path === SD_LANDING_PAGE && sdAgentFlowInProgress && location.pathname === SD_AGENT_PAGE;

  if (showComponents(employerConfigData, route))
    return (
      <Button
        testID="btnRoute"
        variant="rounded"
        bg={isCurrentRoute ? colors.neutral.cotton : colors.secondary.orchid}
        borderWidth={1}
        borderColor={colors.neutral.cotton}
        my="7px"
        onPress={() => {
          if (needsSdAgentGuard) {
            setModal({ ...modal, type: CREATE_MODALS.sdAgentInProgress, screenLink: route?.path });
          } else if (!isFileUploading) {
            AmplitudeHelper.logEvent(route?.amplitudeEvent);
            navigate(route?.path);
          } else {
            showModalForDisableUpload();
          }
        }}
        flexDirection="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Text
          variant={isCurrentRoute ? "xs-bold" : "xs"}
          color={isCurrentRoute ? colors.neutral.charcoal : colors.neutral.cotton}
          alignItems="center"
        >
          {route?.icon}
          {"  "}
          {t(route?.name)}
        </Text>
      </Button>
    );
};

export default RouteButton;
